import React, { Component } from "react";

import { observer, inject } from "mobx-react";

import { Snackbar, IconButton } from "@material-ui/core";

import ClearIcon from "@material-ui/icons/Clear";

@inject("viewStore")
@observer
class SimpleSnackbar extends Component {
    render() {
        return (
            <Snackbar
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                open={this.props.viewStore.snackbarState}
                onClose={() => this.props.viewStore.hideSnackbar()}
                autoHideDuration={5000}
                message={<span id="message-id">{this.props.viewStore.snackbarMessage}</span>}
                action={
                    <IconButton onClick={() => this.props.viewStore.hideSnackbar()} color="primary">
                        <ClearIcon />
                    </IconButton>
                }
            />
        );
    }
}

export default SimpleSnackbar;
